import React, { useState, createContext } from "react";

export const VideoGalleryContext = createContext();

export const VideoGalleryProvider = ({ children }) => {
  const [videoGallery, setVideoGallery] = useState({
    video_gallery_section_title: {
      enable: true,
      title: "My Video Gallery",
    },
    video_gallery_section_icon: {
      enable: false,
      type: "fa", // img || fa
      fa_icon: "bell",
      color: {
        hex: "#ffffff",
        rgb: {
          r: 255,
          g: 255,
          b: 255,
          a: 1,
        },
      },
      preview_file: "", // Existing profile pic
      uploadable_file: "", // file object if new pic selected
      upload: "", // preview link before uploading
    },
    video_gallery_section_background: {
      enable: false,
      color: {
        hex: "#000000",
        rgb: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
      },
    },
    video_link_gallery_section_background: {
      enable: false,
      color: {
        hex: "#000000",
        rgb: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
      },
    },
    video_link_font_and_icon_color: {
      enable: false,
      color: {
        hex: "#000000",
        rgb: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
      },
      font: "verdana",
      font_bold: false,
      font_italic: false,
      font_underline: false,
      font_align_left: false,
      font_align_right: false,
      font_align_center: true,
    },
    gallery_data: [
      {
        enable: true,
        title: "Video title",
        video_url: "https://youtubesdfsdf.com",
        CTAIcon: {
          type: "fa", // img || fa
          fa_icon: "bell",
          color: {
            hex: "#222f4f",
            rgb: {
              r: 34,
              g: 47,
              b: 79,
              a: 1,
            },
          },
          preview_file: "", // Existing pic
          uploadable_file: "", // file object if new pic selected
          upload: "", // preview link before uploading
        },
        cta_text: "CTA Text",
        cta_url: "https://example.com/landingpage",
        password: "",
        show: true,
        schedule: ["", ""],
      },
    ],
  });

  return (
    <VideoGalleryContext.Provider value={[videoGallery, setVideoGallery]}>
      {children}
    </VideoGalleryContext.Provider>
  );
};
